module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-ppt.6d2427c9.png";